"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_getFeesForTransaction_1 = __importDefault(require("./js-getFeesForTransaction"));
const address_1 = require("@celo/utils/lib/address");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const sameFees = (a, b) => (!a || !b ? a === b : a.eq(b));
const prepareTransaction = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    if (transaction.recipient && !(0, address_1.isValidAddress)(transaction.recipient))
        return transaction;
    if (["send", "vote"].includes(transaction.mode) && !transaction.recipient)
        return transaction;
    if (transaction.mode === "vote" &&
        !transaction.useAllAmount &&
        new bignumber_js_1.default(transaction.amount).lte(0))
        return transaction;
    const fees = yield (0, js_getFeesForTransaction_1.default)({ account, transaction });
    if (!sameFees(transaction.fees, fees)) {
        return Object.assign(Object.assign({}, transaction), { fees });
    }
    return transaction;
});
exports.default = prepareTransaction;
//# sourceMappingURL=js-prepareTransaction.js.map